import { render, staticRenderFns } from "./SizeChartModal.vue?vue&type=template&id=03b760b5&"
import script from "./SizeChartModal.vue?vue&type=script&lang=js&"
export * from "./SizeChartModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports